// extracted by mini-css-extract-plugin
export var active = "_2w-1";
export var activeSubdued = "_2w-2";
export var compact = "_2w-3";
export var fill = "_2w-6";
export var pulse = "_2w-4";
export var settingHighlightPulse = "_2w-5";
export var wrapper = "_2w-0";